import { render } from "./TweenNumber.vue?vue&type=template&id=1f1f6904&scoped=true"
import script from "./TweenNumber.vue?vue&type=script&lang=js"
export * from "./TweenNumber.vue?vue&type=script&lang=js"

import "./TweenNumber.vue?vue&type=style&index=0&id=1f1f6904&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1f6904"]])

export default __exports__